import * as Sentry from '@sentry/react';
import { KEY_FLOW_ATTRIBUTE, KeyFlow } from '@seaters/constants';

/**
 * Runs a key user action as the root of a new trace. The apps' `tracesSampler` then samples it at
 * `KEY_FLOW_RATES[flow]`, and the API calls made inside carry that decision to the backends.
 */
export const traceKeyFlow = <T>(
  flow: KeyFlow,
  action: () => Promise<T>
): Promise<T> =>
  Sentry.startNewTrace(() =>
    Sentry.startSpan(
      {
        name: `key_flow.${flow}`,
        op: 'ui.action',
        forceTransaction: true,
        attributes: { [KEY_FLOW_ATTRIBUTE]: flow },
      },
      action
    )
  );
